import React from "react";
import { Modal, Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { Check } from "lucide-react";

const ThanksModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      className="thanks-modal"
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <div className="check-icon-image">
          <Check />
        </div>
        <h2 style={{ marginTop: 16 }}>Thanks for the feedback!</h2>
        <p style={{ color: "#aaa" }}>
          Thank you for appreciating the order! Your review will help us improve
        </p>
        <Button type="default" className="buy-now mx-auto" onClick={onClose}>
          Back
        </Button>
      </div>
    </Modal>
  );
};

export default ThanksModal;
